import { render, staticRenderFns } from "./plateforme_section.vue?vue&type=template&id=479a761a&scoped=true"
import script from "./plateforme_section.vue?vue&type=script&lang=js"
export * from "./plateforme_section.vue?vue&type=script&lang=js"
import style0 from "./plateforme_section.vue?vue&type=style&index=0&id=479a761a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479a761a",
  null
  
)

export default component.exports